import { render, staticRenderFns } from "./MyAnswer.vue?vue&type=template&id=5173fb24&scoped=true&"
import script from "./MyAnswer.vue?vue&type=script&lang=js&"
export * from "./MyAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173fb24",
  null
  
)

export default component.exports